"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uuid = require("uuid");

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const CardRadioGroup = ({
  title,
  radios,
  input,
  ...otherProps
}) => {
  const transformRadios = radios => {
    return radios.map(radio => {
      if (!radio.hasOwnProperty('id')) {
        radio.id = `card-radio-group-${(0, _uuid.v4)()}`;
      }

      return radio;
    });
  };

  radios = transformRadios(radios);
  const radioGroupId = (0, _uuid.v4)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    role: "radiogroup",
    "aria-labelledby": radioGroupId,
    ...otherProps,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.RadioGroupTitle, {
      id: radioGroupId,
      children: title
    }), radios && radios.map((radio, index) => {
      const checked = input.value === radio.value;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Card, {
        outline: true,
        rounded: true,
        checked: checked,
        className: checked ? `radio-group checked` : `radio-group`,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.FormGroup, {
          inline: true,
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Label, {
            inline: true,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Input, {
              type: "radio",
              role: "radio",
              ...input,
              inline: true,
              value: radio.value,
              ...otherProps,
              checked: checked
            }), ' ', radio.label]
          })
        })
      }, index);
    })]
  });
};

CardRadioGroup.propTypes = {
  title: _propTypes.default.string.isRequired,
  radios: _propTypes.default.array.isRequired,
  input: _propTypes.default.object.isRequired
};
var _default = CardRadioGroup;
exports.default = _default;